/** Must match `expiresIn` in backend `controllers/userController.js` → `createToken`. */
export const AUTH_SESSION_MS = 90 * 24 * 60 * 60 * 1000;
export const AUTH_SESSION_DAYS = 90;
